export enum IconColors {
  Default = 'default',
  Warning = 'warning',
  Info = 'info',
  Success = 'success',
  Error = 'error',
}
